import { ColumnsType } from 'antd/lib/table';
import { DonationOutput } from 'gql/types';
import OutcomeCell from 'modules/donations/components/OutcomeCell';
import React from 'react';
import { getTranslation } from 'utils/getTranslation';

import { IDonationTableRow } from '../../types';

const t = getTranslation('dashboard.DonorDashboard.DonationsModal');

export const columns: ColumnsType<IDonationTableRow> = [
  {
    title: t('date'),
    dataIndex: 'date',
    key: 'date',
    render: (v: string) => new Date(v).toLocaleDateString(),
  },
  {
    title: t('location'),
    dataIndex: 'location',
    key: 'location',
  },
  {
    title: t('region'),
    dataIndex: 'region',
    key: 'region',
  },
  {
    title: t('bloodType'),
    dataIndex: 'bloodType',
    key: 'bloodType',
    render: (v: string | null) => v ?? t('unknown'),
  },
  {
    title: t('collectionSet'),
    dataIndex: 'collectionSet',
    key: 'collectionSet',
    render: (v: string) => v ?? t('na'),
  },
  {
    title: t('collectedMl'),
    dataIndex: 'totalCollectedMls',
    key: 'totalCollectedMls',
    render: (v: number | null) =>
      v ? t('milliliters', { value: v }) : t('na'),
  },
  {
    title: t('approvedMl'),
    dataIndex: 'donationMLApprovedAmount',
    key: 'donationMLApprovedAmount',
    render: (v: number | null) =>
      v ? t('milliliters', { value: v }) : t('na'),
  },
  {
    title: t('outcome'),
    key: 'outcome',
    render: (_: unknown, row: IDonationTableRow) => (
      <OutcomeCell donation={row.rawDonation as DonationOutput} />
    ),
  },
  {
    title: t('veterinarian'),
    dataIndex: 'veterinarian',
    key: 'veterinarian',
    render: (v: string | undefined) => v ?? t('na'),
  },
  {
    title: t('capillaryRefill'),
    dataIndex: 'capillaryRefillTime',
    key: 'capillaryRefillTime',
    render: (v: string | undefined) => v ?? t('na'),
  },
];
